import { useState } from "react";

import {
	captureException as sentryCaptureException,
	setUser,
	type SeverityLevel,
	withScope,
} from "@sentry/react";

import type { SentryTag } from "@virtual-brain-lib/types";

export function useSentry() {
	const [nodeEnv, setNodeEnv] = useState<"development" | "production">("development");

	function captureException(
		error: unknown,
		level: SeverityLevel = "error",
		tags?: SentryTag | undefined,
	) {
		if (nodeEnv === "development") {
			console.error(error);
		}

		withScope((scope) => {
			if (tags) {
				scope.setTags(tags);
			}

			scope.setLevel(level);
			sentryCaptureException(error);
		});
	}

	return {
		captureException,
		setUser,
		setNodeEnv,
	};
}
